<template>
  <MainLayout selectMenu="2-1">
    <div v-if="!hasAuth"><NoAuth></NoAuth></div>
    <div v-else>
    <Row class="menu-line" type="flex">
      <Col flex="1" class="menu-actions">
      <Button type="primary" size="small" icon="md-add" @click.native="add()">{{ getTranslation('p001') }}</Button>
      </Col>
    </Row>
    <Affix>
    <Row class="table-header" type="flex">
      <Col flex="1" class="table-cell">{{ getTranslation('m008') }}
      </Col>
      <Col flex="6" class="table-cell">{{ getTranslation('p005') }}
      </Col>
      <Col flex="3" class="table-cell">{{ getTranslation('m013') }}
      </Col>
      <Col flex="9" class="table-cell">{{ getTranslation('p006') }}
      </Col>
      <Col flex="3" class="table-cell">{{ getTranslation('m017') }}
      </Col>
      <Col flex="3" class="table-cell">{{ getTranslation('m018') }}
      </Col>
    </Row>
  </Affix>
    <Row v-for="(item,index) in productline" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
      <Col flex="1" class="table-cell">{{ item.id }}
      </Col>
      <Col flex="6" class="table-cell">{{ item.name }}
      </Col>
      <Col flex="3" class="table-cell">{{ item.seq }}
      </Col>
      <Col flex="9" class="table-cell">{{ item.remark }}
      </Col>
      <Col flex="3" class="table-cell">{{ item.updated_string }}
      </Col>
      <Col flex="3" class="table-cell action-buttons flex-middle">
      <Button size="small" type="primary" icon="md-create" @click.native="edit(item.id)">{{ getTranslation('m019')
      }}</Button>
      <Button size="small" type="error" icon="md-trash" v-if="item.state == 0" @click.native="del(item.id)">{{
        getTranslation('m027') }}</Button>
      <Button size="small" type="success" icon="md-refresh" v-if="item.state != 0" @click.native="recovery(item.id)">{{
        getTranslation('m028') }}</Button>
      </Col>
    </Row>
    <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
      @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
      :page-size-opts=pageSizeAry>{{
        getTranslation('c010') }} {{ total }}
      {{ getTranslation('c011') }}</Page>
    <ProductlineEdit v-model="modalVisible" :propVisible="modalVisible" :editId="editId" @refresh-page="refreshPage">
    </ProductlineEdit>
    </div>
  </MainLayout>
</template>
<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const.js'
import axios from 'axios';

import ProductlineEdit from './components/ProductlineEdit.vue';
import NoAuth from '@/components/NoAuth.vue'
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'ProductlineIndex', // 组件名称
  computed: {
    ...mapGetters(['getTranslation']),
  },
  components: {
    MainLayout, ProductlineEdit,NoAuth, 
  },
  props: {
  },
  data() {
    return {
      productline: [],
      total: 0,
      current: 1,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      modalVisible: false,
      editId: 0,
      pageSizeAry: PAGE_SIZE_ARY,
      hasAuth: true,
    }
  },
  mounted() {
  },
  created() {
    this.setBreadcrumbItems();
    this.getData();

  },
  methods: {
    getData() {
      let url = API_URL["productlineGet"];
      let params = {
        page: this.current,
        page_size: this.pageSize
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.productline = res.data.data.data;
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
            this.translatePageSize();
          } else if (res && res.data && res.data.code == 3001) {            
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('p013'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    add() {
      //0代表新增
      this.editId = 0;
      this.modalVisible = true
    },
    edit(id) {
      //0代表新增
      this.editId = id;
      this.modalVisible = true
    },
    del(id) {

      let url = API_URL["productlineDelete"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(this.getTranslation('p022'));
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    recovery(id) {
      let url = API_URL["productlineRecover"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(this.getTranslation('p023'));
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    refreshPage() {
      this.getData();
    },
    translatePageSize() {
      //let _this = this;
      this.$nextTick(() => {
        /*
        let element = document.querySelectorAll('.page-line .ivu-select-item');        
        if (element.length > 0) {
          element.forEach(el => {
            el.innerHTML = el.innerHTML.replace('条/页',_this.getTranslation('p024'));
          });
        }        
        element = document.querySelectorAll('.page-line .ivu-select-selected-value');        
        if (element.length > 0) {
          element.forEach(el => {
            
            el.innerHTML = el.innerHTML.replace('条/页', _this.getTranslation('p024'));
          });
        } 
        */
      })
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['u045']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('u045') }
        ])
      }      
    }
  },
}
</script>
<style scoped>
@import url('../../assets/style/list.css');
</style>